export default class LocalityService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('localities', params)
	}

	getRelatedLocalities(id, params) {
		return this.apiService.callGet('localities/' + id + '/related_localities', params)
	}

	setRelatedLocalities(id, params) {
		return this.apiService.callPost('localities/' + id + '/related_localities', params)
	}

	getDefaultLocalities(id) {
		return this.apiService.callGet('localities/' + id + '/default_localities')
	}

	setDefaultLocality(id, params) {
		return this.apiService.callPost('localities/' + id + '/default_locality', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('localities/' + id, params)
	}

	updateEntity(id, params){
		return this.apiService.callPut('localities/'+id, params);
	}

	createEntity(params){
		return this.apiService.callPost('localities', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('localities/' + id, params)
	}

	searchLocalities(params){
		return this.apiService.callGet('locality_search', params);
	}

	deleteIpPrefixFromLocality(params){
		return this.apiService.callDelete('locality_delete_ip_prefix', params);
	}

	addIpPrefixToLocality(params){
		return this.apiService.callPost('locality_add_ip_prefix', params);
	}

	updateIpPrefixInLocality(params){
		return this.apiService.callPut('locality_update_ip_prefix', params);
	}

	addContentSourceToLocality(params){
		return this.apiService.callPost('locality_add_content_source', params);
	}

	deleteContentSourceFromLocality(params){
		return this.apiService.callDelete('locality_delete_content_source', params);
	}

	getLocalitiesWithContentSourcesSimple(){
		return this.apiService.callGet('localities/localities_with_content_sources_simple');
	}

}



// WEBPACK FOOTER //
// ./src/service/LocalityService.js